<template>
  <div class="animated-banners grid-bg">
  <b-carousel 
    id="home-page-banners" 
    indicators
    :interval="4000">

   <!-- <b-slide img-blank>
        <div class="banner banner-animated p-image-container-fade-in">
          <div class="animated-banner--bg p-image-container-fade-in--content" id="banner-2-bg">

          </div>
          <img src="@/assets/images/banner-mask.png" class="animated-banner--bg--mask">
          <div class="animated-banner--bg-overlay grid-bg"></div>

        <div class="container">
          <div class="p-css-table p-css-table__fill">
            <div class="p-css-table-row">
              <div class="p-css-table-cell p-css-table-cell__center">
                <div class="animated-banner--text">
                  <h1 class="animated-banner--heading">
                    <span v-for="line in $t('home.slides.cash-back.title').split('\n')" :key="line"> {{line}} </span>
                    <div class="animated-banner--heading-highlighter">
                      <span v-for="line in $t('home.slides.cash-back.title').split('\n')" :key="line"> {{line}} </span>
                    </div>
                  </h1>
                  <div class="animated-banner--sub-heading">
                    <span v-for="line in $t('home.slides.cash-back.description').split('\n')" :key="line"> {{line}} </span>
                  </div>
                 <div class="animated-banner--btn-wrapper">
                    <router-link to="#"
                      class="btn btn-extruded btn-lg-pad animated-banner--cta-btn">
                      <span> {{$t('home.slides.cash-back.button')}} </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-slide>-->

    <b-slide img-blank>
      <div class="banner banner-animated">
        <div class="container">
          <div class="p-css-table p-css-table__fill">
            <div class="p-css-table-row">
              <div class="p-css-table-cell p-css-table-cell__center">
                <div class="animated-banner--text">
                  <div id="banner-1-ill"
                    class="animated-banner--illustration p-image-container-fade-in">
                    <img src="@/assets/images/banner-1-graph.png" id="banner-1-graph">
                    <div id="banner-1-disc" class="p-image-container-fade-in--content">
                      <img src="@/assets/images/home-banner/banner-1-disc.svg"
                        id="banner-1-disc-img">
                      <img id="banner-1-mountain-3"
                        src="@/assets/images/home-banner/banner-1-mountain-3.svg">
                      <img id="banner-1-mountain-2"
                        src="@/assets/images/home-banner/banner-1-mountain-2.svg">
                      <img id="banner-1-mountain-1"
                        src="@/assets/images/home-banner/banner-1-mountain-1.svg">
                      <img id="banner-1-pin"
                        src="@/assets/images/home-banner/banner-1-pin.svg">
                    </div>
                    <img src="@/assets/images/banner-1-line.png" id="banner-1-line">
                  </div>
                  <h1 class="animated-banner--heading">
                    <span v-for="line in $t('home.slides.payout.title').split('\n')" :key="line"> {{line}} </span>
                    <div class="animated-banner--heading-highlighter">
                      <span v-for="line in $t('home.slides.payout.title').split('\n')" :key="line"> {{line}} </span>
                    </div>
                  </h1>
                  <div class="animated-banner--sub-heading">
                    <span v-for="line in $t('home.slides.payout.description').split('\n')" :key="line"> {{line}} </span>
                  </div>
                 <!-- <div class="animated-banner--btn-wrapper">
                    <router-link to="#"
                      class="btn btn-extruded btn-lg-pad animated-banner--cta-btn">
                      <span> {{$t('home.slides.payout.button')}} </span>
                    </router-link>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-slide>

    <b-slide img-blank>
      <div class="banner banner-animated p-image-container-fade-in">
        <div class="animated-banner--bg p-image-container-fade-in--content" id="banner-4-bg">


        </div>
        <img src="@/assets/images/banner-mask.png" id="banner-4-bg-mask"
          class="animated-banner--bg--mask p-image-container-fade-in--content">
        <div class="animated-banner--bg-overlay grid-bg">

        </div>
        <div class="container">
          <div class="p-css-table p-css-table__fill">
            <div class="p-css-table-row">
              <div class="p-css-table-cell p-css-table-cell__center">
                <div class="animated-banner--text">
                  <h1 class="animated-banner--heading">
                    <span v-for="line in $t('home.slides.platforms.title').split('\n')" :key="line"> {{line}} </span>
                    <div class="animated-banner--heading-highlighter">
                      <span v-for="line in $t('home.slides.platforms.title').split('\n')" :key="line"> {{line}} </span>
                    </div>
                  </h1>
                  <div class="animated-banner--sub-heading">
                    <span v-for="line in $t('home.slides.platforms.description').split('\n')" :key="line"> {{line}} </span>
                  </div>
                  <!--<div class="animated-banner--btn-wrapper">
                    <router-link to="#"
                      class="btn btn-extruded btn-lg-pad animated-banner--cta-btn">
                      <span> {{$t('home.slides.platforms.button')}} </span>
                    </router-link>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-slide>

    <b-slide img-blank>
      <div class="banner banner-animated">
        <div class="container">
          <div class="p-css-table p-css-table__fill">
            <div class="p-css-table-row">
              <div class="p-css-table-cell p-css-table-cell__center">
                <div class="animated-banner--text">
                  <div id="banner-3-ill"
                    class="animated-banner--illustration p-image-container-fade-in">
                    <img src="@/assets/images/home-banner/banner-3-graph-grey.svg"
                      id="banner-3-graph-grey">
                    <div id="banner-3-disc" class="p-image-container-fade-in--content">
                      <img src="@/assets/images/home-banner/banner-1-disc.svg"
                        id="banner-3-disc-img">
                      <img src="@/assets/images/home-banner/banner-3-graph.svg"
                        id="banner-3-graph">
                      <div id="banner-3-v-line"></div>
                    </div>
                    <img id="banner-3-pin"
                      src="@/assets/images/home-banner/banner-1-pin.svg">
                    <img src="@/assets/images/banner-3-line.png" id="banner-3-line">
                    <div id="banner-3-stop-watch">
                      <img id="banner-3-stop-watch-shadow"
                        src="@/assets/images/banner-3-shadow.png">
                      <div id="banner-3-stop-button-l-wrapper">
                        <img id="banner-3-stop-button-l"
                          src="@/assets/images/home-banner/banner-3-stop-button-l.svg">
                      </div>
                      <img
                        src="@/assets/images/home-banner/banner-3-stop-button-r.svg">
                      <img src="@/assets/images/home-banner/banner-3-stop-watch.svg">
                      <div id="banner-3-stop-shade-wrapper">
                        <img src="@/assets/images/home-banner/banner-3-stop-shade.svg"
                          id="banner-3-stop-shade">
                      </div>
                      <img id="banner-3-stop-watch-mask"
                        src="@/assets/images/home-banner/banner-3-stop-watch-mask.svg">
                    </div>
                  </div>
                  <h1 class="animated-banner--heading">
                    <span v-for="line in $t('home.slides.demo.title').split('\n')" :key="line"> {{line}} </span>
                    <div class="animated-banner--heading-highlighter">
                      <span v-for="line in $t('home.slides.demo.title').split('\n')" :key="line"> {{line}} </span>
                    </div>
                  </h1>
                  <div class="animated-banner--sub-heading">
                    <span v-for="line in $t('home.slides.demo.description').split('\n')" :key="line"> {{line}} </span>
                  </div>
                 <!-- <div class="animated-banner--btn-wrapper">
                    <router-link to="#"
                      class="btn btn-extruded btn-lg-pad animated-banner--cta-btn">
                      <span> {{$t('home.slides.demo.button')}} </span>
                    </router-link>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-slide>

  </b-carousel>
  </div>
</template>
<script>
  import '@/assets/css/animated-banner.css'
  export default {

  }
</script>